<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<section aria-labelledby="int" epub:type="introduction" role="doc-introduction">
<header>
<h1 class="FMH1" id="int"><span aria-label="1" id="pg_1" role="doc-pagebreak"><span href="#/xhtml/contents#ch_int" title="Link target outside of Sample"><b>INTRODUCTION</b></span></span></h1>
</header>
<p class="TNI">In every book I write, I try to express the</p>
<p class="TNI">amount of strength that can be procured</p>
<p class="TNI">from experiencing heartache.</p>
<p class="TNI">Never <i>settle</i> for any person or <i>stay</i> in</p>
<p class="TNI">any situation that makes you feel</p>
<p class="TNI">small or unimportant.</p>
<p class="TNI"><i>I Needed a Viking</i> was written to</p>
<p class="TNIS">ignite the warrior within you.</p>
<blockquote>
<p class="V1"><i>Don’t be half the person</i></p>
<p class="V"><i>you really are</i></p>
<p class="V"><i>because you think</i></p>
<p class="V"><i>you need to downplay</i></p>
<p class="V"><i>your strength</i></p>
<p class="V"><i>to attract the right one.</i></p>
</blockquote>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introduction.vue?1469a51c